export type ImageSize = 'tiny' | 'wishlist' | 'small' | 'medium' | 'big'

export interface ImageInfo {
  size: ImageSize
  index: number | string
  url: string
}

export interface ImageSrcSet {
  index: number | string
  src: Record<ImageSize, string>
}

export function extractImagesFromArray(imagesNames: string[]): ImageInfo[] {
  return imagesNames
    .map((imageName) => {
      const regExpExecResult = /^.+\_(?<index>\d+)\_(?<size>[^\.\_]+)\.[^\.+]+$/.exec(imageName)
      const { size, index } = regExpExecResult?.groups || {}

      if (size && index) {
        return { size, index, url: imageName }
      }

      return undefined
    })
    .filter((obj) => !!obj) as ImageInfo[]
}

export type ImageInfoByIndex = Record<string, Record<ImageSize, string>>

export function getImagesByIndex(imagesInfos: ImageInfo[]): ImageInfoByIndex {
  return imagesInfos.reduce<ImageInfoByIndex>((result, image) => {
    return { ...result, [image.index]: { ...(result[image.index.toString()] || {}), [image.size]: image.url } }
  }, {})
}

export function extractSrcSetFromImagesNamesArray(imagesNames: string[]): ImageSrcSet[] {
  const imagesInfos = extractImagesFromArray(imagesNames)

  const indexes = [...new Set(imagesInfos.map((info) => info.index))]

  return indexes.map<ImageSrcSet>((imageIndex) => ({
    index: imageIndex,
    src: imagesInfos
      .filter((info) => info.index === imageIndex)
      .reduce(
        (srcSet, info) => ({
          ...srcSet,
          [info.size]: info.url,
        }),
        {} as Record<ImageSize, string>
      ),
  }))
}

// export function extractSrcSetFromImagesNames(imagesNames: string[]): ImageSrcSet {
//     const array = extractSrcSetFromImagesNamesArray(imagesNames)
// }
